import React from 'react';
import css from './ShareListingButton.module.scss';
import { SecondaryButtonInline } from '../Button/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import { isPlatformBrowser } from '../../util/isPlatformBrowser.util';

const ShareListingButton = () => {
  const shareWithFacebook = () => {
    const currentUrl = window.location.href;
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${currentUrl}`, '_blank');
  };

  return (
    <div className={css.sectionShare}>
      <SecondaryButtonInline
        className={css.shareWithFacebookButton}
        onClick={() => shareWithFacebook()}
        quote={'Borrow Online'}
        hashtag="#borrowonline"
      >
        {isPlatformBrowser() && (
          <>
            <FontAwesomeIcon icon="fa-solid fa-share-nodes" className={css.icon} />
            <FormattedMessage id="ShareListingButton.facebook" />
          </>
        )}
      </SecondaryButtonInline>
    </div>
  );
};

export default ShareListingButton;
